export const IconBooleanTrue = () => {
  return (
    <svg
      width='11'
      height='8'
      viewBox='0 0 11 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2078 0.207107C10.4839 0.483249 10.4839 0.930964 10.2078 1.20711L4.20776 7.20711L0.206455 3.2058C-0.0696878 2.92966 -0.0683812 2.48325 0.207761 2.20711C0.483903 1.93096 0.931619 1.93096 1.20776 2.20711L4.20776 5.20711L9.20776 0.207107C9.4839 -0.0690355 9.93162 -0.0690355 10.2078 0.207107Z'
        fill='#3B7DE9'
      />
    </svg>
  );
};

IconBooleanTrue.displayName = 'IconBooleanTrue';
